export default __webpack_public_path__ + "static/media/Lightsaber Luke ROTJ - Img - Wip 7_00.8f15dd3a.jpg";